import { create } from 'zustand';

import type { AuthState, UserProfile } from './types';

type AuthStore = AuthState & {
  setUser: (user: UserProfile) => void;
  clearAuth: () => void;
};

export const useAuthStore = create<AuthStore>((set) => ({
  isAuthenticated: false,
  user: null,
  roles: [],
  setUser: (user) =>
    set({
      isAuthenticated: true,
      user,
      roles: (user.roles || []).filter((role): role is AuthState['roles'][number] =>
        Boolean(role)
      ) as AuthState['roles'],
    }),
  clearAuth: () =>
    set({
      isAuthenticated: false,
      user: null,
      roles: [],
    }),
}));
